import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'
import {ApplyTitle, FirstPageDiv, HeaderArea, HeaderAreaBox} from './NatAdminApplicatioPrintCommonStyle'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {RESIDENT_APPLY_PROCESS, RESIDENT_APPLY_STATUS} from '../../../../../../CodeMaster'
import {NatSealField, SealField} from './NatSealField'
import moment from 'moment'
import {ApplyStatusInfo} from '../../../repository/NatGetApplicationStatus'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'
import {NatBicycleParkingUseWithdrawalDetail} from '../../../repository/NatGetBicycleParkingUseWithdrawal'

interface Props {
    BicycleParkingUseWithdrawalApplicationFormParam: NatBicycleParkingUseWithdrawalDetail
    applyStatusInfoList: ApplyStatusInfo[]
}

export const NatBicycleParkingUseWithdrawalApplicationDocument: React.FC<Props> = props => {
    const {
        applyStatusInfoList
    } = props

    const {
        applyId, condominiumName, ridgeName, roomNumber, applicantFamilyName, applicantFirstName,
        withdrawalArea, withdrawalDate, bicycleCarryingOutDate
    } = props.BicycleParkingUseWithdrawalApplicationFormParam

    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`
    const applicantName = `${applicantFamilyName} ${applicantFirstName}`

    return (<>
        <FirstPageDiv>
            <HeaderArea>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'10mm'}>申請ID：{applyId}</Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitle>自転車置場使用許可解除届</ApplyTitle></Box>
                </HeaderAreaBox>
                <HeaderAreaBox>
                    <Box ml={'auto'} mt={'3mm'}>
                        {renderSealField(applyStatusInfoList)}
                    </Box>
                </HeaderAreaBox>
            </HeaderArea>
            <Box ml={'25mm'} mt={'3mm'}>
                理事長殿
            </Box>
            <Box ml={'30mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　私は、自転車置場使用許可を解除したいので、次のとおり届出をいたします。
            </Box>
            <Box margin={'3mm 0 0 30mm'} display={'flex'} flexDirection={'column'} width={'130mm'}>
                <Box>
                    <Box mb={'5mm'} whiteSpace={'pre-wrap'}>1  申請者</Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('部屋番号', applicantRoom)}
                        {renderApplicationDetail('氏名', applicantName)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('2  使用区画', withdrawalArea)}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('3  解除日', renderUseYearMonth(withdrawalDate))}
                    </Box>
                </Box>
                <Box>
                    <Box mb={'5mm'}>
                        {renderApplicationDetail('4  自転車搬出日', renderUseDate(bicycleCarryingOutDate))}
                    </Box>
                </Box>
            </Box>
        </FirstPageDiv>
    </>)

    NatBicycleParkingUseWithdrawalApplicationDocument.displayName = 'NatBicycleParkingUseWithdrawalApplicationDocument'
}

const renderApplicationDetail = (title: string, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value}/>
        </PrintApplicationDetailContainer>
    )
}

const renderUseDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.day}</Box>日
        </>
    )
}

const renderUseYearMonth = (date: string) => {
    const value = getPrintDate(date)

    return (
        <YearMonthContainer>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} margin={'0 2mm 0 auto'}>末日</Box>
        </YearMonthContainer>
    )
}

const renderSealField = (applyStatusInfoList: ApplyStatusInfo[]) => {
    const sealFields: SealField[] = applyStatusInfoList.map((info) => {
        const applyStatusEnum = RESIDENT_APPLY_PROCESS.codeToEnumConstants(info.applyProcess)
        let seal
        if (info.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
            seal = '却下'
        } else {
            seal = info.actual.registerDatetime ? moment(info.actual.registerDatetime).format('YYYY/M/D') : ''
        }
        return {
            applyStatus: applyStatusEnum.label,
            seal: seal,
            sortOrder: applyStatusEnum.displayOrder
        }
    });

    return (
        <NatSealField sealFields={sealFields}/>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`

const YearMonthContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`
